import { render } from "./SiteFooter.vue?vue&type=template&id=ab109ed2"
const script = {}

import "./SiteFooter.vue?vue&type=style&index=0&id=ab109ed2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__